import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import '../styles/Pages.css';
import { Link } from 'react-router-dom';

const Team = () => {
  const teamMembers = [
    {
      name: 'Edgar Villasmil',
      position: 'CEO & Fundador',
      bio: 'Con más de 15 años de experiencia en tecnología y logística, Edgar fundó VillaTracking con la visión de transformar la gestión de flotas vehiculares en Latinoamérica.',
      image: 'img/ceo.png',
      social: {
        linkedin: 'https://linkedin.com/in/edgarjvh',
        twitter: 'https://twitter.com'
      }
    },
    {
      name: 'Edwin Villasmil',
      position: 'Director de Operaciones',
      bio: 'Experto en logística y cadena de suministro, Miguel ha optimizado las operaciones de numerosas empresas de transporte antes de unirse a VillaTracking.',
      image: 'https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      social: {
        linkedin: 'https://linkedin.com'
      }
    },
    {
      name: 'Ana Martínez',
      position: 'CTO',
      bio: 'Ingeniera de software con especialización en IoT y sistemas de geolocalización. Ana lidera el desarrollo tecnológico de VillaTracking desde sus inicios.',
      image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      social: {
        linkedin: 'https://linkedin.com',
        twitter: 'https://twitter.com'
      }
    },    
    {
      name: 'Laura Sánchez',
      position: 'Directora de Marketing',
      bio: 'Con experiencia en marketing digital y estrategia de marca, Laura ha sido clave en el posicionamiento de VillaTracking en el mercado latinoamericano.',
      image: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      social: {
        linkedin: 'https://linkedin.com',
        twitter: 'https://twitter.com'
      }
    },
    {
      name: 'Roberto Gómez',
      position: 'Director de Ventas',
      bio: 'Especialista en desarrollo de negocios con amplia experiencia en el sector tecnológico. Roberto ha liderado la expansión comercial de VillaTracking.',
      image: 'https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      social: {
        linkedin: 'https://linkedin.com'
      }
    },
    {
      name: 'Patricia Flores',
      position: 'Directora de Atención al Cliente',
      bio: 'Con su enfoque en la excelencia del servicio, Patricia ha desarrollado el premiado programa de soporte técnico y atención al cliente de VillaTracking.',
      image: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      social: {
        linkedin: 'https://linkedin.com',
        twitter: 'https://twitter.com'
      }
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Nuestro Equipo</h1>
            <p>Conoce a los profesionales detrás de VillaTracking</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="team-intro">
              <h2>Un Equipo Apasionado por la Innovación</h2>
              <p>En VillaTracking, contamos con un equipo multidisciplinario de profesionales comprometidos con la excelencia y la innovación. Nuestros colaboradores combinan experiencia en tecnología, logística, atención al cliente y desarrollo de negocios para ofrecer las mejores soluciones de rastreo vehicular del mercado.</p>
            </div>
            
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div className="team-card" key={index}>
                  <div className="team-image">
                    <img src={member.image} alt={member.name} />
                    <div className="team-social">
                      {member.social.linkedin && (
                        <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                          <Linkedin size={18} />
                        </a>
                      )}
                      {member.social.twitter && (
                        <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">
                          <Twitter size={18} />
                        </a>
                      )}
                      <a href={`mailto:${member.name.toLowerCase().replace(' ', '.')}@villatracking.com`}>
                        <Mail size={18} />
                      </a>
                    </div>
                  </div>
                  <div className="team-info">
                    <h3>{member.name}</h3>
                    <p className="team-position">{member.position}</p>
                    <p className="team-bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <div className="join-team">
              <h2>Únete a Nuestro Equipo</h2>
              <p>Estamos siempre en busca de talento apasionado por la tecnología y la innovación. Si te interesa formar parte de VillaTracking, revisa nuestras oportunidades laborales actuales.</p>
              <a href="/careers" className="btn btn-primary">Ver Oportunidades</a>
            </div>
          </div>
        </section>
        
        <section className="page-cta">
          <div className="container">
            <h2>¿Quieres conocer más sobre nosotros?</h2>
            <p>Agenda una llamada con nuestro equipo y descubre cómo podemos ayudarte</p>
            <Link to="/#contact" className="btn btn-primary btn-lg">Contáctanos</Link>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Team;